import { render } from "./PopularServicesModal.vue?vue&type=template&id=afd14d16&scoped=true"
import script from "./PopularServicesModal.vue?vue&type=script&lang=js"
export * from "./PopularServicesModal.vue?vue&type=script&lang=js"

import "./PopularServicesModal.vue?vue&type=style&index=0&id=afd14d16&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afd14d16"]])

export default __exports__